import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { MonthSubcontractorScheduleActionTypes } from "./MonthSubcontractorSchedule.type";

export function* fetchAllMonthSubcontractorSchedules(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/month-subcontractor-schedule?project_id=${action.payload.project_id}&date=${action.payload.date}`);
    yield put({
      type: MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneMonthSubcontractorSchedules(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/month-subcontractor-schedule/${action.payload}`
    );
    yield put({
      type: MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllMonthSubcontractorSchedules() {
  yield takeLatest(MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE, fetchAllMonthSubcontractorSchedules);
}

export function* watcherFetchOneMonthSubcontractorSchedules() {
  yield takeLatest(MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE, fetchOneMonthSubcontractorSchedules);
}
